/**
 * Languages.
 * @module constants/Languages
 */

module.exports = {
  fi: 'Finnish',
  en: 'English',
};
